import React from 'react'
import { Btn, CustomModal } from '../../../../../components'
import { vinho } from '../../../../../assets/js/colors'

// Exibe o token recém-gerado. É a única vez que ele aparece: o TP Manager guarda só o
// prefixo e o hash, então não há como consultá-lo depois.
export default function GeneratedTokenModal({ token, onCopy, onClose }) {
  if (!token) return null

  return (
    <CustomModal header="Token gerado" isVisible={!!token} onClose={onClose} width="720px">
      <div className="p-grid">
        <div className="p-col-12" style={{ color: vinho, fontWeight: 'bold' }}>
          Copie o token agora: ele não será exibido de novo. Envie-o ao parceiro por um canal
          seguro.
        </div>
        <div
          className="p-col-12"
          style={{ fontFamily: 'monospace', wordBreak: 'break-all', userSelect: 'all' }}
        >
          {token}
        </div>
        <div className="p-col-12" style={{ display: 'flex', justifyContent: 'end', gap: 10 }}>
          <Btn onClick={onClose}>Fechar</Btn>
          <Btn onClick={() => onCopy(token)}>Copiar</Btn>
        </div>
      </div>
    </CustomModal>
  )
}
